export const gameStyles = {
  classic: {
    // Stone colors
    firstStoneColor: 'bg-black', // Black
    secondStoneColor: 'bg-white', // White
    firstStoneShadow: 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 shadow-[0_2px_4px_rgba(0,0,0,0.3)]',
    secondStoneShadow: 'bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200 shadow-[0_2px_4px_rgba(0,0,0,0.2)]',
    firstStoneShadowOnDark: 'shadow-white',
    secondStoneShadowOnDark: 'shadow-black',

    // Selected stone colors
    selectedStone: "ring-blue-500/80",

    // Board colors
    boardBackground: '#e1c083', // Light brown/wooden yellowish
    boardShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',

    // Wall colors
    firstPlayerWall: 'bg-black', // Black
    secondPlayerWall: 'bg-white', // White

    // Possible wall colors
    possibleWall: 'bg-blue-500/20 hover:bg-blue-500/60',

    // Cell colors
    cellBorder: '#99804a', // Darker brown for cell borders
    cellHover: 'hover:bg-blue-100',

    // Settled cell colors
    settledFirstStoneCell: 'bg-black/60',
    settledSecondStoneCell: 'bg-white/50',
    settledNeutralCell: 'bg-gray-900/30 opacity-50',

    // Stone points colors
    firstStonePoints: 'text-gray-200 drop-shadow-[0_1px_1px_rgba(0,0,0,0.5)]',
    secondStonePoints: 'text-gray-700 drop-shadow-[0_1px_1px_rgba(255,255,255,0.5)]',

    // Possible move colors
    possibleMove: 'border-blue-500/30',
  },
  original: {
    // Stone colors
    firstStoneColor: 'bg-red-600',
    secondStoneColor: 'bg-blue-600',
    firstStoneShadow: 'bg-gradient-to-br from-red-500 to-red-400 shadow-[0_2px_4px_rgba(0,0,0,0.3)]',
    secondStoneShadow: 'bg-gradient-to-br from-blue-500 to-blue-400 shadow-[0_2px_4px_rgba(0,0,0,0.2)]',
    firstStoneShadowOnDark: 'shadow-sm shadow-white/50',
    secondStoneShadowOnDark: 'shadow-sm shadow-white/50',

    // Selected stone colors
    selectedStone: "ring-white/20",

    // Board colors
    boardBackground: '#916a4e',
    boardShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',

    // Wall colors
    firstPlayerWall: 'bg-red-600/50 border-2 border-black border-opacity-20',
    secondPlayerWall: 'bg-blue-400/80 border-2 border-white border-opacity-20',

    // Possible wall colors
    possibleWall: 'bg-white/20 hover:bg-white/60',

    // Cell colors
    cellBorder: '#a37d62',
    cellHover: 'hover:bg-blue-100/30',

    // Settled cell colors
    settledFirstStoneCell: 'bg-red-300/60',
    settledSecondStoneCell: 'bg-blue-300/50',
    settledNeutralCell: 'bg-gray-900/30 opacity-50',

    // Stone points colors
    firstStonePoints: 'text-gray-200 drop-shadow-[0_1px_1px_rgba(0,0,0,0.5)]',
    secondStonePoints: 'text-gray-200 drop-shadow-[0_1px_1px_rgba(0,0,0,0.5)]',

    // Possible move colors
    possibleMove: 'border-white/30',
  }
}; 
